<div class="goreact-modal share-library-item-dialog-container">
	<div class="modal-dialog">
		<div class="modal-content" cdkTrapFocus>
			<div class="goreact-modal-header">
				<h4 class="modal-title" translate="modal-video-share-dialog_title"></h4>
				<button
					type="button"
					class="close-btn"
					(click)="cancel()"
					[attr.aria-label]="'common_close' | translate"
				>
					<i class="ficon-app-x"></i>
				</button>
			</div>
			<div class="goreact-modal-body" #content [formGroup]="form">
				<div *ngIf="showReviewersField()" class="reviewers-field">
					<p>
						{{ "modal-video-share-dialog_message" | translate }}
						<mat-icon
							matSuffix
							class="ficon-app-help-circle-outline"
							[goTooltip]="'modal-video-share_dialog-help' | translate"
							goTooltipPlacement="top"
						>
						</mat-icon>
					</p>
					<user-form-field
						[peers]="users"
						[allowVideoShare]="data.orgSettings.allow_video_share"
						formControlName="childForm"
					>
					</user-form-field>
					<div class="right-align">
						<button
							*ngIf="showInviteButtonAbove()"
							type="button"
							data-cy="send-invite-button"
							class="confirm-button primary-btn send-invite-btn"
							(click)="sendInvite()"
							[disabled]="isSaving$ | async"
							[focusOnFirstInvalidField]="{
								formGroup: form,
								formWrapper: content
							}"
						>
							{{
								((isSaving$ | async)
									? "invite-user-dialog_sending_invitations"
									: "invite-user-dialog_send_invitations"
								) | translate
							}}
						</button>
					</div>
				</div>
				<div class="separator" *ngIf="showSeparator()">
					<span translate="common_or-uppercase"></span>
				</div>
				<div
					class="public-share-link"
					*ngIf="allowsExternalShare()"
				>
					<div *ngIf="(loading$ | async) else loaded" class="link-loading">
						<i  class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
					</div>
					<ng-template #loaded>
						<div class="create-link" *ngIf="!shareLink">
							<button
								type="button"
								[attr.aria-label]="'modal-video-share_create-public-share-link' | translate"
								data-cy="create-share-link"
								(click)="createPublicShareLink()"
								[disabled]="creatingLink$ | async"
								class="tertiary-btn create-share-tertiary-btn"
							>
								<span
									translate="modal-video-share_create-public-share-link"
								></span>
								<span *ngIf="creatingLink$ | async"
									><i class="ficon-spinner ficon-spin"></i
								></span>
							</button>
						</div>

						<div class="invite-link" *ngIf="shareLink">
							<p translate="modal-video-share_public-share-link"></p>
							<div class="invite-link-group">
								<input
									class="form-control"
									[value]="shareLink"
									data-cy="share-link"
									readonly="readonly"
									[attr.aria-label]="'modal-video-share_public-share-link' | translate"
								/>
								<section [goCopyToClipboard]="shareLink" class="copy-clipboard">
									<button
										type="button"
										class="btn-none"
										[attr.aria-label]="'modal-video-share-dialog_copy' | translate">
										<i class="ficon-app-copy"></i>
									</button>
								</section>
							</div>
						</div>
					</ng-template>
				</div>
			</div>
			<div class="goreact-modal-footer">
				<button
					type="button"
					*ngIf="guestReviewersCount > 0"
					class="tertiary-btn guest-reviewer-cnt-btn"
					(click)="manageVideoSharing()"
					[goTooltip]="'session-list-item_manage-reviewers' | translate"
					goTooltipPlacement="top"
					attr.aria-label="{{ guestReviewersCount > 1 ? 'modal-video-share_guest_reviewers_label-more' : 'modal-video-share_guest_reviewers_label' | translate: { numGuestReviewers: guestReviewersCount } }}">
					<span class="ficon-app-users"></span>
					<span class="guest-reviewer-count">{{ guestReviewersCount }}</span>
				</button>
				<button
					type="button"
					class="cancel-btn"
					[ngClass]="{'tertiary-btn': isPrivateShare() || isExternalVideoShareDisabled(), 'secondary-btn': !isPrivateShare()}"
					data-cy="close-sharing-modal"
					(click)="cancel()"
				>
				{{ (isPrivateShare() || isExternalVideoShareDisabled() ? 'common_cancel' : 'common_close') | translate }}
				</button>
				<button
					*ngIf="isPrivateShare() || isExternalVideoShareDisabled()"
					type="button"
					class="confirm-button primary-btn send-invite-btn"
					(click)="sendInvite()"
					[disabled]="isSaving$ | async"
					[focusOnFirstInvalidField]="{
						formGroup: form,
						formWrapper: content
					}"
				>
					{{
						((isSaving$ | async)
							? "invite-user-dialog_sending_invitations"
							: "invite-user-dialog_send_invitations"
						) | translate
					}}
				</button>
			</div>
		</div>
	</div>
</div>
